import { createFileRoute } from '@tanstack/react-router';
import { toolHead } from '../../../lib/toolHead';
import { TwitchEarningsCalculatorPage } from '../../../pages/tools/creator-tools/TwitchEarningsCalculatorPage';

export const Route = createFileRoute('/_site/tools/twitch-earnings-calculator')({
  head: () => toolHead('twitch-earnings-calculator'),
  component: TwitchEarningsCalculatorPage,
});
